module.exports = __webpack_public_path__ + "static/media/masthead-geraldton-guardian.344b73ec.svg";